export function fabChanged (state, opened) {
  state.fab = opened
}
